/**
 * 'App.routes'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
import store from '@/store/store'
import AppView from '@/views/app/app'
import InvoiceView from '@/views/app/children/invoice.view'
import ClientView from '@/views/app/children/client.view'
import CodesView from '@/views/app/children/codes.view'
import SummaryView from '@/views/app/children/summary.view'
import OrdersView from '@/views/app/children/orders.view'

import PageNotFoundView from '@/views/common/page-not-found.view'

export default [
  {
    path: '/app',
    name: 'app',
    component: AppView,
    children: [
      {
        path: 'invoice',
        name: 'invoice',
        component: InvoiceView,
        beforeEnter (to, from, next) {
          store.dispatch('app/step', 1)
          next()
        }
      },
      {
        path: 'client',
        name: 'client',
        component: ClientView,
        beforeEnter (to, from, next) {
          store.dispatch('app/step', 3)
          next()
        }
      },
      {
        path: 'codes',
        name: 'codes',
        component: CodesView,
        beforeEnter (to, from, next) {
          store.dispatch('app/step', 2)
          next()
        }
      },
      {
        path: 'summary',
        name: 'summary',
        component: SummaryView
      }
    ]
  },
  {
    path: 'orders',
    name: 'orders',
    component: OrdersView,
    beforeEnter (to, from, next) {
      next()
    }
  },
  {
    path: '*',
    name: 'page-not-found',
    component: PageNotFoundView
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/app.routes.js